import axios from 'axios'
import { toolkitUrls } from '@/links'

export async function getSubjectsDomainsGrades() {
  let url = `${toolkitUrls.api}/subjects?refetch=1`
  try {
    let resp = await axios.get(url)
    let subjects = []
    let subjectDomainsMap = {}
    let subjectGradesMap = {}

    resp.data.forEach(subjData => {
      let subject = Object.keys(subjData).filter(key => key !== 'grades')[0]
      subjects.push(subject)
      subjectDomainsMap[subject] = subjData[subject]
      subjectGradesMap[subject] = subjData.grades
    })

    return {
      subjects,
      subjectDomainsMap,
      subjectGradesMap
    }
  } catch (err) {
    throw err.toJSON()
  }
}
